export default __webpack_public_path__ + "static/webRotator/svg/1aaa346521eafbccee4621acbd2a4887.svg";